/**
 * 主商品sku
 */
 import * as React from 'react'
 import ProductSku from './sku-layout';
 import { useAppDispatch } from '../../redux/hooks';
 import { setInfoMap } from '../../redux/reduces/skuSlice';
import SkuNone from './sku-none';
 
 export default function LayoutSku ( props: {
     infoMap: SkuInfoMap
     skuAttrs: SkuAttr[]
     isSample: Boolean
     setInfoMap: any
     type: string
     skuInfoMap: SkuInfoMap
 } ) {
     const { skuInfoMap, type } = props;

     if (!skuInfoMap) {
       return <SkuNone {...props}/>
     }
 
     // 与主商品合并
     const tempInfoMap = {};
     Object.keys( skuInfoMap ).forEach( i => {
         tempInfoMap[i] = {
             // 询盘品无控制
             ...skuInfoMap[i],
             inventoryCount: 99999,
         }
     } )

     const dispatch = useAppDispatch();
     dispatch(setInfoMap({
       type,
       info: tempInfoMap
     }))
 
     return (
         <div className='layout-sku'>
             <ProductSku {...props} showMore startOrder={Object.values(tempInfoMap).filter((i:any) => i.price).length > 0}/>
         </div>
     )
 }
 